(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("animate", [], factory);
	else if(typeof exports === 'object')
		exports["animate"] = factory();
	else
		root["animate"] = factory();
})(this, function() {
return 